export default "__VITE_ASSET__Be$BUG1J__"